class BusinessBaseCounter {
  constructor(section) {
    this.section = section;
    this.grid = section.querySelector('.business-base__grid');
    this.duration = 4000;
    this.animationFrameId = null;
    this.hasStarted = false;
    this.items = this.parseItems();

    if (!this.grid || !this.items.length) {
      return;
    }

    this.init();
  }

  parseItems() {
    const values = Array.from(this.section.querySelectorAll('.business-base__value'));

    return values.map((valueElement) => {
      const prefixElement = valueElement.querySelector('.business-base__value-prefix');
      const prefixHtml = prefixElement ? prefixElement.outerHTML : '';
      const fullText = valueElement.textContent || '';
      const prefixText = prefixElement ? prefixElement.textContent || '' : '';
      const rawText = fullText.replace(prefixText, '').trim();
      const matches = Array.from(rawText.matchAll(/\d+/g));

      if (!matches.length) {
        return null;
      }

      let template = rawText;
      matches.forEach((match, index) => {
        template = template.replace(match[0], `__COUNTER_${index}__`);
      });

      return {
        valueElement,
        prefixHtml,
        template,
        targets: matches.map((match) => Number(match[0])),
      };
    }).filter(Boolean);
  }

  init() {
    if (!('IntersectionObserver' in window)) {
      this.startAnimation();
      return;
    }

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting || this.hasStarted) {
          return;
        }

        this.startAnimation();
        obs.unobserve(entry.target);
      });
    }, {
      threshold: 0.3,
      rootMargin: '0px 0px -10% 0px',
    });

    observer.observe(this.grid);
  }

  startAnimation() {
    this.hasStarted = true;
    const startTime = performance.now();

    const tick = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / this.duration, 1);

      this.items.forEach((item) => {
        const renderedText = item.template.replace(/__COUNTER_(\d+)__/g, (_, index) => {
          const target = item.targets[Number(index)];
          return String(Math.round(target * progress));
        });

        item.valueElement.innerHTML = `${item.prefixHtml}${renderedText}`;
      });

      if (progress < 1) {
        this.animationFrameId = window.requestAnimationFrame(tick);
      }
    };

    this.animationFrameId = window.requestAnimationFrame(tick);
  }
}

document.querySelectorAll('.business-base').forEach((section) => {
  new BusinessBaseCounter(section);
});

